module.exports = __webpack_public_path__ + "static/media/grand_1.841cb658.jpg";